import type { ReactNode } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { Spinner } from '@/components/ui'
import { useAuth } from '@/providers/auth-provider'

export interface GuestRouteProps {
  children?: ReactNode
}

export function GuestRoute({ children }: GuestRouteProps) {
  const { isAuthenticated, isLoading, redirectPath } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Spinner size="lg" label="Checking your session..." />
      </div>
    )
  }

  if (isAuthenticated) {
    return <Navigate to={redirectPath} replace />
  }

  return children ?? <Outlet />
}
